import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    body: 'To proceed with the closure of your account, please **contact us** by clicking below.',
    title: 'Close my account',
  },
  fr: {
    body: 'Pour procéder à la clôture de votre compte, nous vous invitons à **nous contacter** en cliquant ci-dessous.',
    title: 'Clôturer mon compte bancaire',
  },
});

export default locales;
